export default "__VITE_ASSET__CXmehcvC__"